export default __webpack_public_path__ + "static/walls-bb25f30f0a7049de3f21630e39075d85.png";